import React, { useState } from "react";
import Slider from "react-slick";
import FilterButton from "../../atoms/filter-button/filterButton";
import "./filterRegiones.scss";

type FilterRegionesProps = {
    sedes: string[];
    regionChanger: any;
};

function FilterRegiones({ sedes, regionChanger }: FilterRegionesProps) {
    const [chosen, setChosen] = useState("Valle de Aburrá");

    const handleChange = (region: string, active: boolean) => {
        setChosen(region);
        return !active;
    };

    const handleClick = (region: any) => {
        regionChanger(region);
        setChosen(region);
        handleChange(region, region === chosen);
    };

    let regiones: any[];
    regiones = sedes.map((region, index) => {
        return (
            <FilterButton
                key={index}
                active={region === chosen}
                name={region}
                onClick={() => handleClick(region)}
            />
        );
    });

    const settings = {
        dots: false,
        infinite: false,
        centerMode: false,
        slidesToShow: 5,
        slidesToScroll: 7,
        variableWidth: true,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1060,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 8
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 7,
                    slidesToScroll: 7
                }
            },
            {
                breakpoint: 915,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6
                }
            },
            {
                breakpoint: 830,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 590,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 460,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
        ]
    }

    return (<div className="m-filter__btn__container">
        <Slider className="container_slider" {...settings}>
            {regiones}
        </Slider>
    </div>);
}

export default FilterRegiones;
